import React, { useContext, useEffect, useState } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import NewContentToggleItem from "../content_toggles/NewContentToggleItem";
import ContentToggleCarouselSettings from "../content_toggles/ContentToggleCarouselSettings";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import { normalizeObjectsPositions } from "../../utils/builderUtils.js";

const ElementSettingsCarousel = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  let variant = contextData.objects.variant;
  let element = builder.selected().object;

  let sorted_list_items = Object.values(variant.content_toggle_items)
    .filter(
      (list_item) =>
        list_item.element_id == element.id && list_item.toBeDeleted !== true
    )
    .sort((a, b) => a.position - b.position);


  const [activeSlidePosition, setActiveSlidePosition] = useState(1);

  useEffect(() => {
    const element_tag = document.querySelector(`#builder .cf-element[data-element-id="${element.id}"]`);
    const activeSlidePosition = element_tag.getAttribute('data-slide-page');

    setActiveSlidePosition(activeSlidePosition);
  }, [contextData.device, contextData.focused_item_id, contextData.selected_object_id]);

  return (
    <React.Fragment>
      <div className="col-xs-12">
        <div className="w-full relative text-black dark:text-white">
          <span className="text-xl">Slides:</span>
        </div>
      </div>
      <div
        className="sortable-container col-xs-12"
        data-sortable-name="content-toggle-list-items"
        data-object_type="content_toggle_items"
      >
        {normalizeObjectsPositions(sorted_list_items).map((list_item) => {
          return (
            <ContentToggleCarouselSettings
              key={"content_toggle_item-" + list_item.id}
              toggle_item={list_item}
              active={activeSlidePosition == list_item.position}
              {...props}
            />
          );
        })}
      </div>

      {element.element_type == "carousel" && (
        <NewContentToggleItem element={element} />
      )}

      <VariantBuilderSetting
        object={element}
        setting_name="[options][carousel-slides-per-view]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Slides per View"}
        value={
          element.options["carousel-slides-per-view"]
            ? element.options["carousel-slides-per-view"]
            : ""
        }
        placeholder="1"
        min={1}
        max={5}
        range_step={"1"}
        allow_empty={true}
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][carousel-slides-per-view-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Slides per View"}
        value={
          element.options["carousel-slides-per-view-mobile"]
            ? element.options["carousel-slides-per-view-mobile"]
            : ""
        }
        placeholder="1"
        min={1}
        max={5}
        range_step={"1"}
        allow_empty={true}
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Hide Arrow Controls"
        setting_name="[options][carousel-hide-arrow-controls]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["carousel-hide-arrow-controls"]
            ? element.options["carousel-hide-arrow-controls"]
            : "false"
        }
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
      />

      <VariantBuilderSetting
        object={element}
        label="Hide Indicator Controls"
        setting_name="[options][carousel-hide-indicator-controls]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["carousel-hide-indicator-controls"]
            ? element.options["carousel-hide-indicator-controls"]
            : "false"
        }
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
      />

      <VariantBuilderSetting
        object={element}
        label="Swipe Type"
        setting_name="[options][carousel-swipe-type]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["carousel-swipe-type"]
            ? element.options["carousel-swipe-type"]
            : ""
        }
        options={[
          { value: "swiping", text: "Swiping" },
          { value: "scrolling", text: "Scrolling" },
        ]}
      />

      <VariantBuilderSetting
        object={element}
        label="Carousel Sliding Style"
        setting_name="[options][carousel-sliding-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["carousel-sliding-style"]
            ? element.options["carousel-sliding-style"]
            : "default"
        }
        options={[
          { value: "default", text: "Default" },
          { value: "infinite_loop", text: "Infinite Loop" },
        ]}
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
      />

      <VariantBuilderSetting
        object={element}
        label="Overlap Of Next Slide"
        setting_name="[options][show-next-slide-preview]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["show-next-slide-preview"]
            ? element.options["show-next-slide-preview"]
            : "false"
        }
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        label="Show Preview of Next Slide"
        setting_name="[options][show-next-slide-preview-mobile]"
        setting_type="checkbox"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["show-next-slide-preview-mobile"] !== undefined
            ? element.options["show-next-slide-preview-mobile"]
            : element.options["show-next-slide-preview"] !== undefined
            ? element.options["show-next-slide-preview"]
            : "false"
        }
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Next Slide Overlap Percentage"
        setting_name="[options][carousel-next-preview-percentage]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["carousel-next-preview-percentage"]}
        placeholder="20"
        min={1}
        max={100}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        condition={
          element.options["show-next-slide-preview"] === "true"
          && element.options["carousel-swipe-type"] !== "scrolling"
        }
        device="desktop"
      />

      <VariantBuilderSetting
        object={element}
        label="Next Slide Overlap Percentage"
        setting_name="[options][carousel-next-preview-percentage-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        value={element.options["carousel-next-preview-percentage-mobile"]}
        placeholder={element.options["carousel-next-preview-percentage"] || "20"}
        min={1}
        max={100}
        range_step={"1"}
        allow_empty={true}
        show_reset={true}
        condition={
          (element.options["show-next-slide-preview-mobile"] === "true" || element.options["show-next-slide-preview"] === "true")
          && element.options["carousel-swipe-type"] !== "scrolling"
        }
        device="mobile"
      />

      <VariantBuilderSetting
        object={element}
        label="Rotation"
        setting_name="[options][carousel-rotation-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["carousel-rotation-style"]
            ? element.options["carousel-rotation-style"]
            : ""
        }
        condition={element.options["carousel-swipe-type"] !== "scrolling"}
        options={[
          { value: "manual", text: "Manual" },
          { value: "automatic", text: "Automatic" },
        ]}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][carousel-rotation-delay]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Rotation Delay ( seconds )"}
        value={
          element.options["carousel-rotation-delay"]
            ? element.options["carousel-rotation-delay"]
            : ""
        }
        condition={element.options["carousel-rotation-style"] == "automatic"
          && element.options["carousel-swipe-type"] !== "scrolling"}
        min={1}
        max={60}
        range_step={"1"}
        placeholder={variant.options["carousel-rotation-delay"] || "5"}
        allow_empty={true}
      />
    </React.Fragment>
  );
};

export default ElementSettingsCarousel;
